import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLicenseOverview as GetLicenseOverviewQuery,
    GetLicenseOverview_licenseOverview as LicenseOverview,
} from 'nutshell-graphql-types';

import GET_LICENSE_OVERVIEW from '../queries/get-license-overview.graphql';

export const useGetLicenseOverview = (): {
    isLoading: boolean;
    licenseOverview: LicenseOverview;
    errorMessage: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetLicenseOverviewQuery, Record<any, any>>(
        GET_LICENSE_OVERVIEW,
        {
            fetchPolicy: 'network-only',
        }
    );
    const {licenseOverview} = makeDataDangerous(data);

    return {
        isLoading: loading,
        licenseOverview,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
